<span *ngIf="!(isHandset$ | async)" class="path">
	<span *ngFor="let breadcrumb of breadcrumbsService.breadcrumbs$ | async | slice:2:-1">
		<a [routerLink]="breadcrumb.url">{{ breadcrumb | breadcrumbLabel }}</a>
		<span class="divider"> / </span>
	</span>
</span>
<span *ngFor="let breadcrumb of breadcrumbsService.breadcrumbs$ | async | slice:-1">{{ breadcrumb | breadcrumbLabel }}</span>
